export const convertPathToTag = path => {
  // Takes a data path like 'EEligibilityStateRequirements.RONRequirements.ApprovedByAgency'
  // and returns 'RONRequirements_ApprovedByAgency'. To be used to create labels for data-test attributes.
  return typeof path === 'string' ? path.split('.').slice(1).join('_') : undefined;
};
